var _a;
import { ComponentContext, elementsToShapes, SeatingViewerContext, IconType } from '@wix/seating-common-components';
import { Enter, Exit, Elevator, Stairs, Bar, Cutlery, Smoking, Wc, WcWomen, WcMen } from 'wix-ui-icons-common';
import React, { useMemo } from 'react';
import { Seat } from '../seat';
import { Area } from '../area';
import { Shapes } from '../shapes';
import s from './plan.scss';
var viewerComponents = {
    Seat: Seat,
    Area: Area,
    PointerArea: function () { return null; },
    SelectionMarker: function () { return null; },
    Icons: (_a = {},
        _a[IconType.enter] = Enter,
        _a[IconType.exit] = Exit,
        _a[IconType.elevator] = Elevator,
        _a[IconType.stairs] = Stairs,
        _a[IconType.drinks] = Bar,
        _a[IconType.food] = Cutlery,
        _a[IconType.smoking] = Smoking,
        _a[IconType.wc] = Wc,
        _a[IconType.wcWomen] = WcWomen,
        _a[IconType.wcMen] = WcMen,
        _a),
};
export var Plan = function (_a) {
    var plan = _a.plan, svgViewBox = _a.svgViewBox, currentlyClickedPlaceId = _a.currentlyClickedPlaceId, selectedPlaceIds = _a.selectedPlaceIds, placesStock = _a.placesStock, _b = _a.mobile, mobile = _b === void 0 ? false : _b, onPlaceClick = _a.onPlaceClick, onPlaceMouseEnter = _a.onPlaceMouseEnter, onPlaceMouseLeave = _a.onPlaceMouseLeave;
    var shapes = useMemo(function () { return elementsToShapes(plan, true); }, [plan]);
    var seatingViewContextValue = useMemo(function () { return ({
        currentlyClickedPlaceId: currentlyClickedPlaceId,
        selectedPlaceIds: selectedPlaceIds,
        placesStock: placesStock,
        mobile: mobile,
        onPlaceClick: onPlaceClick,
        onPlaceMouseEnter: onPlaceMouseEnter,
        onPlaceMouseLeave: onPlaceMouseLeave,
    }); }, [
        currentlyClickedPlaceId,
        selectedPlaceIds,
        placesStock,
        mobile,
        onPlaceClick,
        onPlaceMouseEnter,
        onPlaceMouseLeave,
    ]);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: s.plan, viewBox: svgViewBox },
        React.createElement(ComponentContext.Provider, { value: viewerComponents },
            React.createElement(SeatingViewerContext.Provider, { value: seatingViewContextValue },
                React.createElement(Shapes, { shapes: shapes })))));
};
//# sourceMappingURL=plan.js.map